import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "kwikui-label-value-pair-label",
  templateUrl: "./label-value-pair-label.component.html",
  styleUrls: ["./label-value-pair-label.component.css"]
})
export class LabelValuePairLabelComponent implements OnInit {
  @Input()
  label;

  @Input()
  config;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty("label") && !changes.label.firstChange) {
      this.label = changes.label.currentValue;
    }

    if (changes.hasOwnProperty("config") && !changes.config.firstChange) {
      this.config = changes.config.currentValue;
    }
  }
}
